<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="inform-boxlp">
      <div class="box-left">
        <div class="left-top">
          <div class="shijuan">试卷摘要：</div>
          <div class="shi-heng"></div>
          <div class="shi-text">
            试卷一共{{ fenzhi.zong }}道题，其中单选题{{
              fenzhi.dan_num
            }}题（每题{{ fenzhi.dan_score }}分）、判断{{
              fenzhi.pan_num
            }}题（每题{{ fenzhi.pan_score }}分）、多选{{
              fenzhi.duo_num
            }}题（每题{{ fenzhi.duo_score }}分）。总分{{
              fenzhi.zong
            }}分，大于或等于{{ fenzhi.pass_mark }}分通过考试。
          </div>
        </div>
        <div class="datika">
          <div class="dati-ka">答题卡：</div>
          <div class="dati-ge"></div>
          <div class="danxuan">1.单选题</div>
          <div class="shuzik">
            <div
              class="one"
              @click="danxuang(inde0, item)"
              :class="[item.addnumber ? 'lkout' : '']"
              v-for="(item, inde0) in topic"
              :key="inde0"
            >
              {{ inde0 + 1 }}
            </div>
          </div>
          <div class="danxuan">2.多选题</div>
          <div class="shuzilk">
            <div
              class="onek"
              @click="duoxuang(inx1, item)"
              :class="[item.addnumbar ? 'kout' : '']"
              v-for="(item, inx1) in topi"
              :key="inx1"
            >
              {{ inx1 + 1 }}
            </div>
          </div>
          <div class="danxuan">3.判断题</div>
          <div class="shuzi">
            <div
              class="onekh"
              @click="panduan(send, item)"
              :class="[item.addnumbor ? 'kouto' : '']"
              v-for="(item, send) in judge"
              :key="send"
            >
              {{ send + 1 }}
            </div>
          </div>
        </div>
      </div>
      <div class="box-right">
        <div class="content-list">
          <div class="list-title">{{ fenzhi.examname }}</div>
          <div class="title-right">
            <div class="right-left">考试时间：</div>
            <div class="right-miao">
              {{ hours }}时{{ minutes }}分{{ seconds }}秒
            </div>
          </div>
        </div>
        <!-- 单选题 -->
        <div class="dati-gex"></div>
        <div class="title-tst">
          一.单选题({{ fenzhi.dan_num }}题.每题{{ fenzhi.dan_score }}分)
        </div>
        <div
          class="danxuanp"
          v-for="(item, sent0) in topic"
          :key="sent0"
          @click="commmin(item, sent0)"
          :id="item.id"
        >
          <div class="dati-l">
            <div>{{ sent0 + 1 }}.</div>
            <div class="l-right" v-html="item.content"></div>
          </div>
          <div class="l-timu">
            <div
              class="timu-l"
              v-for="(items, inexp) in item.option"
              :key="inexp * 5"
            >
              <input
                class="input-l"
                type="radio"
                :name="'!' + item.id"
                :value="items.name"
                @click="checkRadio"
                :id="items.sel"
              />
              <label :for="items.sel">
                <div class="input-text" v-if="item.type == 1">
                  {{ items.name }}.{{ items.gender }}
                </div>
                <div v-else class="img-kl">
                  <div class="img-lk">{{ items.name }}</div>
                  <viewer :images="items.gender" :toolbar="false">
                    <img
                      :id="items.gender"
                      :src="items.gender"
                      alt
                      class="box-img"
                    />
                  </viewer>
                </div>
              </label>
            </div>
          </div>
        </div>
        <!-- 多选题 -->
        <div class="title-tst">
          二.多选题({{ fenzhi.duo_num }}题.每题{{ fenzhi.duo_score }}分)
        </div>
        <div
          class="danxuanp"
          v-for="(item, currented) in topi"
          :key="currented"
          @click="commmia(item, currented)"
          :id="item.id"
        >
          <div class="dati-l">
            <div>{{ currented + 1 }}.</div>
            <div class="l-right" v-html="item.content"></div>
          </div>
          <div class="l-timu">
            <div
              class="timu-l"
              v-for="(items, idexq) in item.option"
              :key="idexq"
            >
              <input
                class="input-l"
                type="checkbox"
                :name="items.name"
                :value="items.name"
                @click="moreseTi"
                :data-id="item.id"
                :id="items.sels"
              />
              <label :for="items.sels">
                <div class="input-text" v-if="item.type == 1">
                  {{ items.name }}.{{ items.gender }}
                </div>
                <div v-else class="img-kl">
                  <div class="img-lk">{{ items.name }}</div>
                  <img :src="items.gender" alt class="box-img" />
                </div>
              </label>
            </div>
          </div>
        </div>
        <!-- 判断 -->
        <div class="title-tst">
          三.判断题({{ fenzhi.pan_num }}题.每题{{ fenzhi.pan_score }}分)
        </div>
        <div
          class="danxuanp"
          v-for="(item, cured6) in judge"
          :key="item.id"
          @click="commmiVedict(item, cured6)"
          :id="item.id"
        >
          <div class="dati-h">
            <div>{{ cured6 + 1 }}.</div>
            <div class="l-right" v-html="item.content"></div>
          </div>
          <div class="h-xuan">
            <div
              class="h-xuan-left"
              v-for="(items, curedIndex) in item.option"
              :key="curedIndex * 10"
            >
              <input
                class="nan"
                type="radio"
                @click="verdict"
                :name="'_' + item.id"
                :value="items.name"
                :id="items.self"
              />
              <label :for="items.self">
                <div class="nanl">{{ items.name }}.{{ items.gender }}</div>
              </label>
            </div>
          </div>
        </div>

        <div class="jiaojuan">
          <div class="jiao-btn" @click="addf">交卷</div>
        </div>
        <div class="buhege" v-if="isbox">
          <img class="yihan" src="../../assets/yihan_img@2x.png" alt />
          <div class="chengji">{{ numbar.score }}</div>
          <div class="ningde">您的成绩</div>
          <div class="yihan-text">
            真遗憾，您没能通过本次考试！
            <br />
            您还有{{ numbar.num }}次考试机会，下次要继续加油哦！
          </div>
          <div class="dibu-btn">
            <div class="jinru" v-if="numbar.num != 0" @click="jinru">
              进入我的考试
            </div>
            <div class="jixu" v-if="numbar.num != 0" @click="jinru">
              继续考试
            </div>
            <div class="jinru" v-if="numbar.num == 0" @click="jinru">
              进入我的考试
            </div>
          </div>
        </div>
        <div class="buhege" v-if="ishow">
          <img class="yihan" src="../../assets/zan_img@2x.png" alt />
          <div class="chengji">{{ numbar.score }}</div>
          <div class="ningde">您的成绩</div>
          <div class="yihan-text">
            恭喜您，顺利通过了本次考试！
            <br />未来也要继续加油哦！
          </div>
          <div class="dibu-btnl">
            <div class="xiazai" @click="jinrut">下载合格证书</div>
          </div>
        </div>
        <div class="zhexiu-ceng" v-if="tan"></div>
      </div>
    </div>
    <dibu></dibu>
    <daohan></daohan>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      isbox: false,
      ishow: false,
      tan: false,
      id: "",
      topic: [],
      topi: [],
      judge: [],
      fenzhi: [],
      time: "",
      question_id: "",
      type: 1,
      answer: "",
      answer3: '',
      study_exam_num: "",
      anserarrduo: [], // 多选答案
      nserarr: [],
      num: "",
      numbar: "",
      days: "",
      hours: "",
      minutes: "",
      seconds: "",
      pass_mark: "",
      pan_score: "",
      bei_ing: this.Public.bei_ing,
      radio: '',  // 单选
      multiple: '',  // 多选
      decide: '',// 判断
    };
  },
  mounted() {
    this.id = this.$route.query.id;

    console.log(this.id);
    this.getquestion();
    this.getfen();
  },

  methods: {
    //单选题
    danxuang(index, item) {
      let target = index;
      document.getElementById(item.id).scrollIntoView();
    },
    //多选题
    duoxuang(index, item) {
      let target = index;
      document.getElementById(item.id).scrollIntoView();
    },
    //判断题
    panduan(index, item) {
      let target = index;
      document.getElementById(item.id).scrollIntoView();
    },
    //进入我的考试
    jinru() {
      this.$router.push({
        path: "/profile",
        query: { id: this.id },
      });
      console.log(this.id);
    },
    //点击下载证书
    jinrut() {
      this.$router.push({ path: "/certificate", query: { id: this.num, order: this.id } });
    },

    commmin(item, sent0) {   //  单选 点击答案
      this.radio = sent0;
      console.log("单选题", item);
      console.log('单选id', item.id);
      console.log("单选题的索引", sent0);
    },

    checkRadio(e) {   //  单选 提交答案
      var that = this;
      console.log(e);
      setTimeout(function () {
        that.topic[that.radio].addnumber = true;
      }, 30);
      let value = e.target.value, name = e.target.name;
      name = this.$common.getCaption(name)
      that.answer = value;
      that.type = 1;
      that.question_id = name;
      console.log(value);
      that.subquestion();
    },
    subquestion() {   //答案接口
      let that = this, url = "exam/exam_answer", param = {
        study_id: that.id,
        question_id: that.question_id,
        type: that.type,
        answer: that.answer,
        study_exam_num: that.study_exam_num,
      };
      this.post(url, param)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    commmia(item, index) {   //点击答案  多选题
      this.multiple = index;
      console.log('commmia多选1', item);
      console.log('commmia多选2', index);
    },
    moreseTi(e) {  // 多选
      let that = this;
      setTimeout(function () {
        that.topi[that.multiple].addnumbar = true;
      }, 30);
      let newanserarr = [];
      let ids = e.target.dataset.id;
      if (that.question_id == ids) {
        newanserarr = this.anserarrduo;
      } else {
        that.answer = []
        newanserarr = [];
      }
      that.question_id = ids;
      that.type = 2;

      if (e.target.checked == true) {
        newanserarr.push(e.target.name);
      } else {
        newanserarr.forEach(function (value, index, array) {
          if (value == e.target.name) {
            newanserarr.splice(index, 1);
          }
        });
      }
      let newty = newanserarr.join(",");
      this.anserarrduo = newanserarr;
      this.answer = newty;
      // 提交答案
      this.subquestion();
    },

    commmiVedict(item, index) {  //   判断  点击答案
      this.decide = index;
      console.log(item);
      console.log(index);
    },
    // 判断
    verdict(e) {
      console.log(e);
      let that = this;
      setTimeout(function () {
        that.judge[that.decide].addnumbor = true;
      }, 30);
      console.log(e);
      let value = e.target.defaultValue;
      let name = e.target.name;
      console.log(name, "name");
      name = name.split('_')
      this.answer3 = value;
      this.type = 3;
      this.question_id = name;
      console.log(value);
      this.subquestion3();
    },
    subquestion3() {   //答案接口
      let that = this, url = "exam/exam_answer", param = {
        study_id: that.id,
        question_id: that.question_id,
        type: that.type,
        answer: that.answer3,
        study_exam_num: that.study_exam_num,
      };
      this.post(url, param)
        .then((res) => {
          console.log(res);
          console.log(this.topic, 'topic单选');
          console.log(this.topi, 'topi');
          console.log(this.judge, 'judge【判断');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //交卷
    addf() {
      console.log(this.num);
      let that = this;
      var url = "exam/tijiao";
      let param = {
        id: this.num,
      };
      this.post(url, param)
        .then((res) => {
          this.numbar = res.data;
          this.pan_score = res.data.score;
          if (this.pan_score < this.pass_mark) {
            this.isbox = true;

            this.tan = true;
          } else if (this.pan_score >= this.pass_mark) {
            this.ishow = true;
            this.isbox = false;
            this.tan = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //开始考试
    getquestion() {
      let that = this, url = "exam/question", param = {
        study_id: this.id,
      };
      this.post(url, param)
        .then((res) => {
          for (var i = 0; i < res.data.dan.length; i++) {
            res.data.dan[i]["addnumber"] = false;
          }
          for (var i = 0; i < res.data.duo.length; i++) {
            res.data.duo[i]["addnumbar"] = false;
          }
          for (var i = 0; i < res.data.pan.length; i++) {
            res.data.pan[i]["addnumbor"] = false;
          }
          this.study_exam_num = res.data.exam_num;
          this.topic = res.data.dan;
          this.topic.forEach(function (value) {
            value.selname = "";
          });
          this.topi = res.data.duo;
          this.judge = res.data.pan;
          for (var i = 0; i < res.data.dan.length; i++) {
            for (var j = 0; j < res.data.dan[i].option.length; j++) {
              res.data.dan[i].option[j].sel = "name" + res.data.dan[i].id + j;
            }
            this.optiont = res.data.dan[i].option;
          }
          for (var i = 0; i < res.data.duo.length; i++) {
            for (var j = 0; j < res.data.duo[i].option.length; j++) {
              res.data.duo[i].option[j].sels = "namea" + res.data.duo[i].id + j;
            }
            this.opti = res.data.duo[i].option;
          }
          for (var i = 0; i < res.data.pan.length; i++) {
            for (var j = 0; j < res.data.pan[i].option.length; j++) {
              res.data.pan[i].option[j].self = "namev" + res.data.pan[i].id + j;
            }
            this.ot = res.data.pan[i].option;
          }
          this.topic = this.topic;
          this.num = res.data.third_exam_id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //分值接口
    getfen() {
      let that = this;
      var url = "exam/index";
      let param = {
        study_id: this.id,
      };
      this.post(url, param)
        .then((res) => {
          let that = this;
          this.fenzhi = res.data;
          this.time = res.data.examdurationtime * 60;
          this.pass_mark = res.data.pass_mark;

          var interval = setInterval(
            function () {
              // 秒数
              var second = this.time;

              // 天数位
              var day = Math.floor(second / 3600 / 24);
              var dayStr = day.toString();
              if (dayStr.length == 1) dayStr = "0" + dayStr;
              // 小时位
              var hr = Math.floor((second - day * 3600 * 24) / 3600);
              var hrStr = hr.toString();
              if (hrStr.length == 1) hrStr = "0" + hrStr;
              // 分钟位
              var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60);
              var minStr = min.toString();
              if (minStr.length == 1) minStr = "0" + minStr;
              // 秒位
              var sec = second - day * 3600 * 24 - hr * 3600 - min * 60;
              var secStr = sec.toString();
              if (secStr.length == 1) secStr = "0" + secStr;

              that.days = dayStr;
              that.hours = hrStr;
              that.minutes = minStr;
              that.seconds = secStr;
              this.time--;
              // console.log(that.days);
              if (this.time <= 0) {
                clearInterval(interval);
                // 倒计时结束
                // that.countDown();
                that.days = "00";
                that.hours = "00";
                that.minutes = "00";
                that.seconds = "00";
              }
            }.bind(this),
            1000
          );

          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.viewer-toolbar {
  display: none;
}
</style>
<style scoped>
@import "../../css/answer.css";
</style>